/*------------ Mobile Sidebar ----------------*/

var stat;

function handleMousePos(event) {
    if (stat == 1) {
        var mouseClickWidth = event.clientX;
        const box = document.getElementById('mySidebar');
        if (!box.contains(event.target)) {
            closeNav();
        }
    }
}

document.addEventListener("click", handleMousePos);

function openNav() {
    document.getElementById("mySidebar").style.width = "80%";
    document.getElementById("mySidebar").style.transition = "0.3s";
    document.getElementById("mySidebar").style.boxShadow = "0 0 0 10000px rgba(0,0,0,.75) ";
    document.getElementById("SidebarUl").style.opacity = "1";
    document.getElementById("SidebarUl").style.transition = "0.2s";

    var delayInMilliseconds = 100; //1 second

    setTimeout(function() {
        stat = 1;
    }, delayInMilliseconds);

}

function closeNav() {
    document.getElementById("mySidebar").style.width = "0";
    document.getElementById("mySidebar").style.boxShadow = "none ";
    document.getElementById("SidebarUl").style.opacity = "0 ";
    document.getElementById("SidebarUl").style.transition = "0.2s";
    stat = 0;

}

function OpenLi(clickedID) {
    var elementid = document.getElementById(clickedID);
    let str = clickedID;
    str = str.substring(1);
    // alert(str);
    // if ("NavItem1" == clickedID) {
    var Imgid = document.getElementById(str);
    Imgid.style.width = "80%";
    Imgid.style.left = "0";
    abc = Imgid;
    // }
}

function backtoNav() {
    var ccc = abc;
    ccc.style.width = "0";
    ccc.style.left = "-100px";

}

/* --------------- SLIDERS -------------------*/


var swiper = new Swiper(".productsSL", {
    slidesPerView: 2,
    spaceBetween: 15,
    navigation: {
        nextEl: ".swiper-button-next2",
        prevEl: ".swiper-button-prev2",
    },
    breakpoints: {
        640: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        768: {
            slidesPerView: 3
        }
    },
});



$('.product_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.product_slider_thumbs',
    prevArrow:'<i class="fas fa-chevron-left product_slider_arrow_prev"></i>',
    nextArrow:'<i class="fas fa-chevron-right product_slider_arrow_next"></i>'
  });

$('.product_slider_thumbs').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow:'',
    nextArrow:'',
    asNavFor: '.product_slider',
    focusOnSelect: true
  });

function OpenCartDr(){
$(".drawer").toggleClass("active");
}